<template>
  <div class="social overFlowXauto">
    <div class="social-left">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="switchVal"
        @nodeClick="nodeClick"
      ></Tree>
    </div>
    <div class="social-right">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="setSearchParams"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      >
      </Table>
    </div>
    <!-- 发布招领 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'发布招领'"
      :visible.sync="addDialogVisible"
      width="450px"
      :before-close="addHandleClose"
    >
      <editForm
        ref="editForm"
        :formConfig="addFormConfig"
        :rules="addRules"
        :ruleForm="addRuleForm"
        :buttonConfig="addButtonConfig"
      ></editForm>
    </el-dialog>
    <!-- 查看详情 -->
    <!-- 查看详情 -->
    <el-dialog
      :title="'查看详情'"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <div class="form-detail">
        <div class="user-info">
          <div class="user-img">
            <el-avatar shape="square" :size="100" :src="detailInfo.portrait"></el-avatar>
          </div>
          <div class="user-detail">
            <div class="item-box">
              <div class="item-title">姓名：</div>
              <div class="item-value">{{ detailInfo.realName }}</div>
            </div>
            <div class="item-box">
              <div class="item-title">手机号：</div>
              <div class="item-value">{{ detailInfo.phone }}</div>
            </div>
            <div class="item-box">
              <div class="item-title">发布时间：</div>
              <div class="item-value">{{ detailInfo.createGmt }}</div>
            </div>
          </div>
          <div
            class="status"
            v-if="detailInfo.enable && !detailInfo.finished"
            style="color: green"
          >
            已启用
          </div>
          <div
            class="status"
            v-if="detailInfo.enable && detailInfo.finished"
            style="color: green"
          >
            已完成
          </div>
          <div
            class="status"
            v-if="!detailInfo.enable && !detailInfo.finished"
            style="color: red"
          >
            已禁用
          </div>
        </div>
        <div class="info-list">
          <div><span>拾取地址:</span>{{ detailInfo.address }}</div>
          <div><span>详细内容:</span>{{ detailInfo.content }}</div>
        </div>

        <div class="info-list" v-if="!detailInfo.enable">
          <div><span>审核备注:</span>{{ detailInfo.enableRemark }}</div>
        </div>
      </div>
      <div class="form-btn" v-if="detailInfo.creatorId == userId && !detailInfo.finished">
        <el-button type="success" @click="closeDialog">已解决,关闭招领</el-button>
      </div>
    </el-dialog>
    <!-- 批量禁用 -->
    <el-dialog
      :title="'禁用说明'"
      :visible.sync="ignoreDialogVisible"
      width="500px"
      :before-close="ignoreHandleClose"
    >
      <div class="input-label">
        <div class="label">审核备注</div>
        <div class="input">
          <el-input
            type="textarea"
            :disabled="isShowIgnore"
            :autosize="{ minRows: 4, maxRows: 8 }"
            placeholder="请输入内容"
            v-model="ignoreTextarea"
          ></el-input>
        </div>
      </div>
      <div class="ignore-btn">
        <el-button v-if="!isShowIgnore" type="danger" @click="ignoreConfirm"
          >禁用</el-button
        >
        <el-button type="primary" @click="ignoreHandleClose">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Tree from "../../../../components/Tree/nodeTree";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import { assitanceApi } from "../../../../api-path/assitance-api.js";
export default {
  components: {
    Tree,
    TabelSearch,
  },
  data() {
    return {
      detailInfo: {},
      ignoreDialogVisible: false,
      isShowIgnore: false,
      ignoreList: [],
      ignoreTextarea: "",

      squareUrl: "",
      switchVal: false,
      userId: JSON.parse(localStorage.getItem("ur")).id,
      //表格start
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "search",
            valueType: "text",
            placeholder: "请输入关键词",
          },
        ],
      },
      searchParams: {
        search: "",
        areaId: "",
        areaName: "",
        page: 1,
        size: 15,
      },
      tableLoading: false,
      tabelButtons: [
        {
          type: "add",
          fn: () => {
            (this.addRuleForm = {
              title: "",
              pickTime: "",
              address: "",
              content: "",
              longtitude: "",
              latitude: "",
              areaId: this.areaId,
            }),
              (this.addDialogVisible = true);
          },
        },
        {
          type: "forbidden", //
          title: "批量禁用",
          fn: (data) => {
            data.map((item) => {
              this.ignoreList.push(item.id);
            });
            this.ignoreTextarea = "";
            this.isShowIgnore = false;
            this.ignoreDialogVisible = true;
          },
        },
      ],
      tableTemplateData: [],
      tableConfig: {
        checkbox: true,
        checkboxFn: (data) => {},
        rows: [
          {
            label: "区域",
            prop: "areaName",
          },
          {
            label: "标题",
            prop: "title",
			width:"150px",
			type:'popover'
          },
          {
            label: "内容",
            prop: "content",
			width:"200px",
			type:'popover'
          },
          {
            label: "地址",
			prop: "address",
			width:"200px",
			type:'popover'
          },
          {
			label: "发布时间",
			width:'140px',
            prop: "createGmt",
          },
          {
            label: "是否完成",
            type: "status",
            prop: "finished",
            activeColor: "",
            activeText: "已完成",
            text: "未完成",
          },
          {
            label: "是否禁用",
            type: "status",
            prop: "enable",
            activeColor: "",
            activeText: "已启用",
            text: "已禁用",
            showWord: false,
            fn: (data) => {
              if (!data.enable) {
                this.ignoreDialogVisible = true;
                this.isShowIgnore = true;
                this.ignoreTextarea = data.enableRemark
                  ? data.enableRemark
                  : "暂无审核信息";
              } else {
                this.ignoreDialogVisible = true;
                this.isShowIgnore = false;
                this.ignoreTextarea = "";
                this.ignoreList = [data.id];
              }
            },
          },
        ],
        rowButtons: {
          width: "300px",
          items: [
            {
              label: "查看",
              fn: (data) => {
                this.detailInfo = data;
                this.dialogVisible = true;
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      },
      //表格end
      dialogVisible: false,
      //表单配置start
      addDialogVisible: false,
      addRuleForm: {
        title: "",
        pickTime: "",
        address: "",
        content: "",
        longtitude: "",
        latitude: "",
        areaId: "",
      },
      addRules: {
        title: [
          {
            required: true,
            trigger: "change",
            message: "请填写标题",
          },
        ],
        pickTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择时间",
          },
        ],
        address: [
          {
            required: true,
            trigger: "change",
            message: "请填写地址",
          },
        ],
        latitude: [
          {
            required: true,
            trigger: "change",
            message: "请绑定经纬度",
          },
        ],
      },
      addFormConfig: {
        ref: "editMap",
        disabled: false,
        items: [
          [
            {
              valueType: "input", // 类型
              label: "标题",
              key: "title", // 数据名称
              prop: "title", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "100%",
              placeholder: "请输入标题", // 提示信息
            },
          ],
          [
            {
              valueType: "datetime", // 类型
              label: "拾取时间",
              key: "pickTime", // 数据名称
              prop: "pickTime", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "100%",
              placeholder: "请选择时间", // 提示信息
            },
          ],
          [
            {
              key: "latitude",
              prop: "latitude",
              label: "经纬度",
              valueType: "nautica",
              placeholder: "请绑定经纬度",
              itemWidth: "100%",
              labelWidth: "100px", // label 宽度
              fn: (data) => {
                this.addRuleForm.address = data.siteName;
                this.addRuleForm.latitude = data.location.latitude;
                this.addRuleForm.longitude = data.location.longitude;
              },
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "拾取地址",
              key: "address", // 数据名称
              prop: "address", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "100%",
              disabled: true,
              placeholder: "请绑定地址", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "详细内容",
              key: "content", // 数据名称
              prop: "content", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "500",
              itemWidth: "100%",
              placeholder: "详细内容", // 提示信息
            },
          ],
        ],
      },
      addButtonConfig: {
        buttons: [
          {
            type: "save", // 发布
            loading: false,
            fn: (data) => {
              console.log(data);
              this.$http.post(assitanceApi.lostSave, data).then((res) => {
                if (res.status === 200) {
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  this.addDialogVisible = false;
                  this.setSearchParams();
                }
              });
            },
          },
          {
            type: "back", // 重置
            fn: () => {
              this.addDialogVisible = false;
            },
          },
        ],
      },
      //表单配置end
    };
  },
  methods: {
    //批量禁用start
    ignoreHandleClose() {
      this.ignoreDialogVisible = false;
    },
    ignoreConfirm() {
      let params = {
        ids: this.ignoreList,
        enable: false,
        enableRemark: this.ignoreTextarea,
      };
      if (this.ignoreTextarea != "") {
        this.$http.post(assitanceApi.setEnable, params).then((res) => {
          if (res.status == 200) {
            this.$message({
              type: "success",
              message: "操作成功！",
            });
            this.ignoreDialogVisible = false;
            this.setSearchParams();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "请输入审核信息！",
        });
      }
    },
    //批量禁用end
    changeSwitch(e) {
      this.switchVal = e;
      this.isDown = e;
      this.searchParams.isDown = e;
      this.setSearchParams();
    },
    nodeClick(node) {
      this.searchParams.areaId = node.id;
      this.addRuleForm.areaId = node.id;
      this.areaId = node.id;
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.setSearchParams();
    },
    resetCallBack() {
      this.searchParams.areaId = this.areaId;
      this.searchParams.isDown = this.isDown;
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.setSearchParams();
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.setSearchParams();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.setSearchParams();
    },
    setSearchParams() {
      this.$http
        .get(assitanceApi.lostQueryListByPage, { params: this.searchParams })
        .then((res) => {
          if (res.status === 200) {
            this.tableTemplateData = res.result.pageList;
            this.pagination.total = res.result.total;
          }
        });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    //关闭招领
    closeDialog(id) {
      this.$http.get(assitanceApi.setFinished, { params: { id: id } }).then((res) => {
        if (res.status == 200) {
          this.dialogVisible = false;
          this.setSearchParams();
        }
      });
    },
    //新增
    addHandleClose() {
      this.addDialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.social {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;

  .social-left {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .social-right {
	flex: 1;
	display: flex;
	flex-direction: column;
  }

  //查看
  .form-detail {
    height: 30vh;
    overflow-y: scroll;
    .info-list {
      .clues-title {
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
      }
    }
    .user-info {
      display: flex;
      // background: #e7f6fb;
      padding: 10px;
      border-radius: 5px;

      .user-detail {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 80px;
        margin-left: 20px;
        flex: 1;
      }
    }

    .item-box {
      display: flex;
      margin-top: 20px;
      position: relative;
      align-items: center;

      .status {
        position: absolute;
        right: 0;
        color: red;
      }
    }
  }

  .form-btn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  .input-label {
    .input {
      margin: 30px 0;
      .el-textarea {
        width: 100%;
      }
    }
  }
  .ignore-btn {
    display: flex;
    justify-content: center;
  }
  //是否有偿
  .money-box {
    display: flex;
    margin-bottom: 30px;
    .label {
      width: 100px;
      text-align: right;
      padding: 0 12px 0 0;
      box-sizing: border-box;
      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
    }
    .money {
      display: flex;
      flex-direction: column;
      .el-input-number {
        width: auto;
      }
      .money-input {
        margin: 10px 0 0 0;
      }
    }
  }
}
</style>
